/** What the storm guard lets through for one more crash of the same kind. */
export enum CrashStormVerdict {
	/** Send the crash. */
	Send = 'send',
	/** The first crash over the limit for this error: send one warning instead. */
	ErrorLimitReached = 'error-limit',
	/** The first crash over the limit for the page: send one warning instead. */
	PageLimitReached = 'page-limit',
	/** Over a limit already warned about: send nothing. */
	Drop = 'drop',
}
